import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import dayjs, { Dayjs } from 'dayjs';

import Forms from '../workorder/form-work';
import Tableworkorder from '../workorder/table';
import HeaderMMS from '../header/header';
import MenuMMS from '../menu/menu';
import { setFullLoad, setSnackMsg } from "../../redux/actions/common";
import { baseUrl } from "../../constants";
import { getUserProfile } from '../../redux/selector';
import Select from '@mui/material/Select';
import { fetchDropDown, debounce } from "../../utils";
import {
    getDDFacilityCall, getDDEquCall, getDDSubEquCall,
    getDDDeviceCall, getDDJobProCall, getDDJobNatureCall,
    getDDWorkCall, getDDEmployeeCall, getDDJobStatusCall,
    getDDTagCall, getDDWorkCenterCall, getDDTaskCall,
    getDDDeptCall, getDDCompCall, getDDLocCall, getDDAreaCall,
    getDDOrderTypeCall
} from "../../redux/actions/dropDown";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { dropDownNode } from "../../utils";
import { getDropDown } from "../../redux/selector";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            style={{
                width: "calc(100vw - 155px)"
            }}
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));
export default function Settings({ type }) {
    const [open, setOpen] = React.useState(false);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [tableData, setTableData] = React.useState([]);
    const dispatch = useDispatch();
    const userDetails = useSelector(getUserProfile);
    const dropDownState = useSelector(getDropDown);
    const [dropDownVal, setDropDownVal] = useState(dropDownState || {});

    const fetchTableData = (payload) => {        
        if(payload?.fromDateF){ delete payload.fromDateF; }
        if(payload?.toDateF){ delete payload.toDateF; }
        dispatch(setFullLoad(true));
        // console.log(userDetails);
        const url = type === 'workorder' ? `${baseUrl}/api/work/work_order/list` : `${baseUrl}/api/work/daily_log/list`;
        fetch(url, {
            method: "POST",
            body: JSON.stringify(payload || {}),
            headers: { "Content-type": "application/json; charset=UTF-8" }
        })
            .then((response) => {
                return response.json();
            })
            .then(({ data = [] }) => {
                setTableData(data || []);
                dispatch(setFullLoad(false));
            });
    };

    const getDD = React.useCallback(
        debounce(() => {
            fetchDropDown(dispatch, [
                getDDOrderTypeCall, getDDAreaCall, getDDDeptCall,                 
                getDDSubEquCall, getDDDeviceCall, 
                getDDJobProCall, getDDJobNatureCall, getDDJobStatusCall,
                getDDWorkCall, getDDEmployeeCall, 

                // getDDTagCall, getDDWorkCenterCall, getDDTaskCall, 
                //getDDCompCall, getDDLocCall,              
                
                // getDDFacilityCall, getDDEquCall, 

            ]);
        }, 200),
        []
    );

    React.useEffect(() => {
        getDD();
        fetchTableData();
    }, []);
    React.useEffect(() => {
        setDropDownVal(dropDownState || {});
    }, [dropDownState]);

    const handleApply = () => {
        console.log(formData);
        fetchTableData(formData);
    };
    const handleClose = () => {
        setOpenDialog(false);
    };
    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const headerProps = {
        open, handleDrawerOpen
    }
    const menuProps = {
        setOpen, open
    }
    const tableProps = {
        setOpenDialog,
        tableData,
        userDetails,
        WOType: 'daily'
    };   
        
    const handleTree = (name, value) => {
    let planFacility = formData.planFacility;
    let equipment = formData.equipment;
    let equipmentType = formData.equipmentType;
    let equipmentCapacity = formData.equipmentCapacity;
    let equipmentTag = formData.equipmentTag;
    if(name === 'area') {
        planFacility = ''; equipment = ''; equipmentType = ''; 
        equipmentCapacity = ''; equipmentTag = '';
        dispatch(getDDFacilityCall({area_id: value}));
    }
    else if(name === 'planFacility') {
        equipment = ''; equipmentType = ''; equipmentCapacity = ''; equipmentTag = '';
        dispatch(getDDEquCall({facility_id: value}));
    }
    // else if(name === 'equipment') {
    //     equipmentType = ''; equipmentCapacity = ''; equipmentTag = '';
    //     dispatch(getDDequipTypeCall({equipment_id: value}));
    // }
    // else if(name === 'equipmentType') {
    //     equipmentCapacity = ''; equipmentTag = '';
    //     dispatch(getDDEquipmentCapacityCall({equipment_type_id: value}));
    // }
    // else if(name === 'equipmentCapacity') {
    //     equipmentTag = '';
    //     dispatch(getDDEquipmentTagCall({equipment_capacity_id: value}));
    // }
    };

    const [formData, setFormData] = useState({});
    const [fields, setFields] = useState([{ value: '' }]);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        handleTree(name, value);
        setFormData({
            ...formData,
            [name]: value
        });
    };
    const handleDateChange = (date, field, dateField) => {
        const updatedVal = dayjs(date).format('YYYY-MM-DD');
        console.log(updatedVal);
        setFormData({
            ...formData,
            [field]: updatedVal,
            [dateField]: date
        });
    };
    const handleSubmitForm = () => {
        console.log(formData);
    }
    const handleClearForm = () => {
        setFormData({
            createdBy: '',
        });
    };
    const DrawerHeader = styled('div')(({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    }));

    const handleExportCSV = () => {
        // const formData = new FormData();
        // formData.append("job_id", body.job_id); 
        fetch(`https://api-fluid.quixlab.in/api/work/work_order/export?${new URLSearchParams(formData).toString()}`, {
              method: "GET",
              headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    Accept: "application/pdf, application/xml, application/octetstream"
                },                
                // body: JSON.stringify(formData || {}),
                // body: formData
            })
            .then(res => res.blob())
            .then(res => {
                console.log(res);
                const fileName = 'Daily Log';
                //Check the Browser type and download the File.
                var isIE = false || !!document.documentMode;
                if (isIE) {
                    window.navigator.msSaveBlob(res, fileName);
                } else {
                    var url = window.URL || window.webkitURL;
                    const link = url.createObjectURL(res);
                    var a = document.createElement("a");
                    a.setAttribute("download", fileName);
                    a.setAttribute("href", link);
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }
                // successCb(res.data);
            })
            .catch((error, res ,a,b) => {
                console.log(error, res ,a,b);
                console.error(error);
            })
    };

    const handleExportPDF = () => {
        fetch(`https://api-fluid.quixlab.in/api/work/work_order/export`, {
              method: "GET",
              headers: {
                    "Content-type": "application/json; charset=UTF-8",                    
                    Accept: "application/pdf, application/xml, application/octetstream"
                }
            })
            .then(res => res.blob())
            .then(res => {
                console.log(res);
                const fileName = 'Daily Log';
                //Check the Browser type and download the File.
                var isIE = false || !!document.documentMode;
                if (isIE) {
                    window.navigator.msSaveBlob(res, fileName);
                } else {
                    var url = window.URL || window.webkitURL;
                    const link = url.createObjectURL(res);
                    var a = document.createElement("a");
                    a.setAttribute("download", fileName);
                    a.setAttribute("href", link);
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }
                // successCb(res.data);
            })
            .catch((error, res ,a,b) => {
                console.log(error, res ,a,b);
                console.error(error);
            })
    };

    return (
        <Box sx={{ display: 'flex' }}>

            <HeaderMMS {...headerProps} />
            <MenuMMS {...menuProps} />
            <Box component="main" sx={{ flexGrow: 1, p: 3 }} className='bg-slate-100 mms-cnt-main overflow-hidden'>
                <Grid className='bg-slate-100 '>
                    <DrawerHeader />
                    {/* <Forms /> */}
                    <div className='rounded p-3 text-lg text-left font-semibold'>
                        <h2> Log Reports</h2>
                    </div>

                    <div className="mms-report-sec">

                        <div className='text-left bg-white  m-2 border-solid border rounded'>
                            {/* <h1 className='font-bold text-center'>Warrenty Reports</h1> */}
                            <div className="mms-date-field">
                                <Grid container xs={12} sm={12} className='items-start'>
                                    <Grid item xs={12} md={2} container>
                                        <Grid item xs={12} sm={12} className='p-2 mms-datepicker'>
                                            <LocalizationProvider label="Date" dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    label="From Date"
                                                    value={formData.fromDateF}
                                                    className='w-full'
                                                    onChange={(date) => handleDateChange(date, 'fromDate', 'fromDateF')}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </Grid>



                                        <Grid item xs={12} sm={12} className='p-2  mms-datepicker'>
                                            <LocalizationProvider label="Date" dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    label="To Date"
                                                    value={formData.toDateF}
                                                    className='w-full'
                                                    onChange={(date) => handleDateChange(date, 'toDate', 'toDateF')}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </Grid>

                                        <Grid item xs={12} sm={12} className='p-2 mms-selectfield'>

                                            <FormControl sx={{ width: "100%" }}>
                                                <InputLabel id="ordertype">Order Type</InputLabel>
                                                <Select
                                                    name="orderType"
                                                    value={formData.orderType}
                                                    label="Order Type"
                                                    onChange={handleInputChange}
                                                >
                                                    {dropDownNode([ {id: 1, name: 'internal'}, {id: 2, name: 'external'} ])}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        {/* <Grid item xs={12} sm={12} className='p-2 mms-selectfield'>

                                            <FormControl sx={{ width: "100%" }}>
                                                <InputLabel id="location">Location </InputLabel>
                                                <Select
                                                    name="location"
                                                    value={formData.location}
                                                    label="Location "
                                                    onChange={handleInputChange}
                                                >
                                                    {dropDownNode(dropDownVal.loc_id || [])}
                                                </Select>
                                            </FormControl>
                                        </Grid> */}
                                        <Grid item xs={12} sm={12} className='p-2 mms-selectfield'>

                                            <FormControl sx={{ width: "100%" }}>
                                                <InputLabel id="department ">Order From </InputLabel>
                                                <Select
                                                    name="orderFrom"
                                                    value={formData.orderTo}
                                                    label="Department"
                                                    onChange={handleInputChange}
                                                >
                                                    {dropDownNode(dropDownVal.department_id || [])}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={12} className='p-2 mms-selectfield'>

                                            <FormControl sx={{ width: "100%" }}>
                                                <InputLabel id="department ">Order To </InputLabel>
                                                <Select
                                                    name="orderTo"
                                                    value={formData.orderTo}
                                                    label="Department"
                                                    onChange={handleInputChange}
                                                >
                                                    {dropDownNode(dropDownVal.department_id || [])}
                                                </Select>
                                            </FormControl>
                                        </Grid>



                                        <Grid item xs={12} sm={12} className='p-2 mms-selectfield'>

                                            <FormControl sx={{ width: "100%" }}>
                                                <InputLabel id="area">Area</InputLabel>
                                                <Select
                                                    name="area"
                                                    value={formData.area}
                                                    label="Area"
                                                    onChange={handleInputChange}
                                                >
                                                    {dropDownNode(dropDownVal.area_id || [])}
                                                </Select>
                                            </FormControl>
                                        </Grid>




                                        <Grid item xs={12} sm={12} className='p-2 mms-selectfield'>
                                            <FormControl sx={{ width: "100%" }}>
                                                <InputLabel id="facility">Facility</InputLabel>
                                                <Select
                                                    name="planFacility"
                                                    value={formData.planFacility}
                                                    label="Facility"
                                                    onChange={handleInputChange}
                                                >
                                                    {dropDownNode(dropDownVal.facility_id || [])}
                                                </Select>
                                            </FormControl>

                                        </Grid>
                                        <Grid item xs={12} sm={12} className='p-2 mms-selectfield'>
                                            <FormControl sx={{ width: "100%" }}>
                                                <InputLabel id="equipment">Equipment</InputLabel>
                                                <Select
                                                    name="equipment"
                                                    value={formData.equipment}
                                                    label="Equipment"
                                                    onChange={handleInputChange}
                                                >
                                                    {dropDownNode(dropDownVal.equipment_id || [])}
                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid item xs={12} sm={12} className='p-2 mms-selectfield'>
                                            <FormControl sx={{ width: "100%" }}>
                                                <InputLabel id="subEquipment">Sub Equipment</InputLabel>
                                                <Select
                                                    name="subEquipment"
                                                    value={formData.subEquipment}
                                                    label="Equipment"
                                                    onChange={handleInputChange}
                                                >
                                                    {dropDownNode(dropDownVal.sub_equipment_id || [])}
                                                </Select>
                                            </FormControl>

                                        </Grid>
                                        <Grid item xs={12} sm={12} className='p-2 mms-selectfield'>
                                            <FormControl sx={{ width: "100%" }}>
                                                <InputLabel id="device">Device / Inst</InputLabel>
                                                <Select
                                                    name="deviceInstrument"
                                                    value={formData.deviceInstrument}
                                                    label="Device / Inst"
                                                    onChange={handleInputChange}
                                                >
                                                    {dropDownNode(dropDownVal.device_id || [])}
                                                </Select>
                                            </FormControl>

                                        </Grid>
                                        <Grid item xs={12} sm={12} className='p-2 mms-selectfield'>
                                            <FormControl sx={{ width: "100%" }}>
                                                <InputLabel id="priority">Priority</InputLabel>
                                                <Select
                                                    name="jobPriority"
                                                    value={formData.jobPriority}
                                                    label="Priority"
                                                    onChange={handleInputChange}
                                                >
                                                    {dropDownNode(dropDownVal.job_priority_id || [])}
                                                </Select>
                                            </FormControl>

                                        </Grid>


                                        <Grid item xs={12} sm={12} className='p-2 mms-selectfield'>
                                            <FormControl sx={{ width: "100%" }}>
                                                <InputLabel id="status">Status</InputLabel>
                                                <Select
                                                    name="job_status"
                                                    value={formData.job_status}
                                                    label="Status"
                                                    onChange={handleInputChange}
                                                >
                                                    {dropDownNode(dropDownVal.job_status || [])}
                                                </Select>
                                            </FormControl>

                                        </Grid>




                                        <Grid item xs={12} sm={12} className='p-2 mms-selectfield'>
                                            <FormControl sx={{ width: "100%" }}>
                                                <InputLabel id="jobnature">Job Nature</InputLabel>
                                                <Select
                                                    name="jobNature"
                                                    value={formData.jobNature}
                                                    label="Job Nature"
                                                    onChange={handleInputChange}
                                                >
                                                    {dropDownNode(dropDownVal.job_nature_id || [])}
                                                </Select>
                                            </FormControl>

                                        </Grid>




                                        <Grid item xs={12} sm={12} className='p-2 mms-selectfield'>
                                            <FormControl sx={{ width: "100%" }}>
                                                <InputLabel id="attendedby">Assigned To</InputLabel>
                                                <Select
                                                    name="assignedTo"
                                                    value={formData.assignedTo}
                                                    label="Attendedby"
                                                    onChange={handleInputChange}
                                                >
                                                    {dropDownNode(dropDownVal.employee_id || [])}
                                                </Select>
                                            </FormControl>

                                        </Grid>
                                        <Grid item xs={12} sm={12} className='p-2 mms-selectfield'>
                                            <FormControl sx={{ width: "100%" }}>
                                                <InputLabel id="createdby">Created By</InputLabel>
                                                <Select
                                                    name="createdBy"
                                                    value={formData.createdBy}
                                                    label="Created By"
                                                    onChange={handleInputChange}
                                                >
                                                    {dropDownNode(dropDownVal.employee_id || [])}
                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid item xs={12} sm={12} className='p-3 '>
                                            <button class="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded inline-flex items-center"
                                            onClick={handleClearForm}>Clear</button>
                                            <button 
                                            class="bg-blue-700 hover:bg-blue-800 text-white font-bold py-2 px-4 rounded inline-flex items-center ml-2"
                                            onClick={handleApply}
                                            >Apply</button>
                                        </Grid>
                                        <Grid item xs={12} sm={12} >
                                            <h3 className='p-2'>Logs By  Work Reference</h3>
                                            <Grid item xs={12} sm={12} className='p-2 mms-selectfield'>
                                                <FormControl sx={{ width: "100%" }}>
                                                    <InputLabel id="reportbyworkorder">Report by Work order iD</InputLabel>
                                                    <Select
                                                        name="reportedBy"
                                                        value={formData.reportedBy}
                                                        label="Report by Work order iD"
                                                        onChange={handleInputChange}
                                                    >
                                                        {dropDownNode(dropDownVal.employee_id || [])}
                                                    </Select>
                                                </FormControl>

                                            </Grid>
                                            <Grid item xs={12} sm={12} className='p-2'>
                                                <TextField size='small' label="Log No" variant="outlined"
                                                    name="reference_number"
                                                    value={formData.reference_number}
                                                    sx={{ width: '100%' }}
                                                    onChange={handleInputChange} />
                                            </Grid>
                                            <button class="bg-green-700 hover:bg-green-800 text-white font-bold py-2 px-4 rounded inline-flex items-center ml-2 mb-2"
                                            onClick={handleApply}
                                            >Search</button>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} md={10} container>
                                        <Grid item xs={12} sm={12} className='p-3 '>
                                            <div class="space-x-4 ml-auto float-right">

                                                <button class="bg-purple-700 hover:bg-purple-800 text-white font-bold py-2 px-4 rounded inline-flex items-center"
                                                    onClick={handleExportPDF}
                                                >
                                                    <PictureAsPdfIcon></PictureAsPdfIcon>

                                                    PDF
                                                </button>


                                                <button class="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded inline-flex items-center"
                                                    onClick={handleExportCSV}
                                                >
                                                    <svg class="w-5 h-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 18L22 12m0 0l-6-6m6 6H2" />
                                                    </svg>
                                                    CSV
                                                </button>


                                                <button class="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded inline-flex items-center">
                                                    <svg class="w-5 h-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16m-7 4h7" />
                                                    </svg>
                                                    Excel
                                                </button>
                                            </div>
                                        </Grid>

                                        <CustomTabPanel value={0} index={0} className="overflow-hidden">
                                            <Box className='bg-slate-100 mms-table-sec'>
                                                <Tableworkorder {...tableProps} />

                                            </Box>
                                        </CustomTabPanel>
                                    </Grid>
                                </Grid>
                                <BootstrapDialog
                                    className="mms-full-dig"
                                    onClose={handleClose}
                                    aria-labelledby="customized-dialog-title"
                                    open={openDialog?.formType}
                                >
                                    <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" className='bg-sky-600 text-white'>
                                        Edit Daily Log Reques
                                    </DialogTitle>
                                    <IconButton
                                        aria-label="close"
                                        onClick={handleClose}
                                        sx={{
                                            position: 'absolute',
                                            right: 8,
                                            top: 8,
                                            color: (theme) => theme.palette.grey[500],
                                        }}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                    <DialogContent dividers>
                                        <Forms
                                            handleClose={handleClose}
                                            formDataObj={openDialog}
                                            fetchTableData={fetchTableData}
                                            WOType={'daily'}
                                            userDetails={userDetails}
                                        />
                                    </DialogContent>
                                    <DialogActions>

                                    </DialogActions>
                                </BootstrapDialog>
                            </div>
                        </div>
                    </div>






                </Grid>
            </Box>
        </Box>
    );

}